export default "__VITE_ASSET__Bosw7fEk__"